/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { type Amount, AmountFromJSONTyped, AmountToJSON, AmountToJSONTyped } from './Amount';
import { type Percentage, PercentageFromJSONTyped, PercentageToJSON, PercentageToJSONTyped } from './Percentage';
import { type SkipPrompt, SkipPromptFromJSONTyped, SkipPromptToJSON, SkipPromptToJSONTyped } from './SkipPrompt';
/**
 * 
 * @export
 * @interface HubTerminalTipOptions
 */
export interface HubTerminalTipOptions {
    /**
     * 
     * @type {string}
     * @memberof HubTerminalTipOptions
     */
    type: string;
}

/**
 * Check if a given object implements the HubTerminalTipOptions interface.
 */
export function instanceOfHubTerminalTipOptions(value: object): value is HubTerminalTipOptions {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function HubTerminalTipOptionsFromJSON(json: any): HubTerminalTipOptions {
    return HubTerminalTipOptionsFromJSONTyped(json, false);
}

export function HubTerminalTipOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): HubTerminalTipOptions {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'Amount') {
            return AmountFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'Percentage') {
            return PercentageFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'SkipPrompt') {
            return SkipPromptFromJSONTyped(json, ignoreDiscriminator);
        }

    }
    return {
        
        'type': json['type'],
    };
}

export function HubTerminalTipOptionsToJSON(json: any): HubTerminalTipOptions {
    return HubTerminalTipOptionsToJSONTyped(json, false);
}

export function HubTerminalTipOptionsToJSONTyped(value?: HubTerminalTipOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['type']) {
            case 'Amount':
                return AmountToJSONTyped(value as Amount, ignoreDiscriminator);
            case 'Percentage':
                return PercentageToJSONTyped(value as Percentage, ignoreDiscriminator);
            case 'SkipPrompt':
                return SkipPromptToJSONTyped(value as SkipPrompt, ignoreDiscriminator);
            default:
                return value;
        }
    }

    return {
        
        'type': value['type'],
    };
}

